import * as React from 'react';
import {classNames} from '@shopify/react-utilities/styles';
import {Flex, Text, TextProps} from 'components/UIKit';
import {Omit} from '../../../helpers/typeHelpers';
import styles from './ActionListItem.scss';

interface PermittedTextProps
  extends Omit<TextProps, 'secondary' | 'emphasis' | 'type' | 'align' | 'style' | 'children'> {}

type DivElementProps = JSX.IntrinsicElements['div'];

interface ActionListItemProps extends DivElementProps {
  label: string;
  leftAddon?: React.ReactNode;
  rightAddon?: React.ReactNode;
  hasHoverBorder?: boolean;
  hasPaddingOffset?: boolean;
  showInteractionState?: boolean;
  wrapperComponent?: string;
  textProps?: Partial<PermittedTextProps>;
}

export function ActionListItem(props: ActionListItemProps) {
  const {
    label,
    leftAddon,
    rightAddon,
    hasHoverBorder,
    hasPaddingOffset,
    showInteractionState = false,
    wrapperComponent = 'div',
    textProps = {},
    ...restProps
  } = props;

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      className={classNames(styles.label, {
        [styles.interactionState]: showInteractionState,
        [styles.hoverBorder]: hasHoverBorder,
        [styles.hasPaddingOffset]: hasPaddingOffset,
      })}
      wrapperComponent={wrapperComponent}
      {...restProps}
    >
      {Boolean(leftAddon) && leftAddon}
      <Text text={label} type="small" resetMargin ellipsis {...textProps} />
      {Boolean(rightAddon) && rightAddon}
    </Flex>
  );
}
